import { FC, ReactNode } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { CalendarIcon } from "src/assets/Icons";

const Trigger: FC<{ children: ReactNode; onClick?: () => void }> = ({ children, onClick }) => {
  const { t } = useTranslation();

  return (
    <div
      onClick={onClick}
      className={cn(
        "bg-background-default border-border-default flex w-full items-center gap-3 rounded-full border p-1.5 pe-4",
        onClick && "cursor-pointer",
      )}
    >
      <span className="bg-background-primary-lighter text-icon-active flex size-10 shrink-0 items-center justify-center rounded-full">
        <CalendarIcon className="size-4" />
      </span>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="text-font-subtle flex text-xs font-medium uppercase tracking-wider">
          <span className="flex-1">{t("UserHistory.ordersList.from")}</span>
          <span className="w-4 shrink-0" />
          <span className="flex-1">{t("UserHistory.ordersList.to")}</span>
          <span className="w-5 shrink-0" />
        </div>
        {children}
      </div>
    </div>
  );
};

export default Trigger;
